import { render } from "./PostLikeButton.vue?vue&type=template&id=efc36ba6&scoped=true"
import script from "./PostLikeButton.vue?vue&type=script&lang=js"
export * from "./PostLikeButton.vue?vue&type=script&lang=js"

import "./post-like-button.scss?vue&type=style&index=0&id=efc36ba6&lang=scss&scoped=true"

import exportComponent from "/Users/tathonglam/docker/src/client/weconcept/star168.hk/star168_backend.git/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efc36ba6"]])

export default __exports__